import Vue from 'vue';
export const store = new Vue({
  data: {
    user: {id: -1, login: ""},
  },
});


// WEBPACK FOOTER //
// ./src/javascript/store.js